// ================= ТЕМА СВІТУ «Бурштинова діорама» =================
// Художній напрям: макет району під настільною лампою вдень, сузір'я бурштинового
// світла в чорнильно-синій ночі — ніч ніколи не чорна. Два дискретні стани:
// перемикаємо їх лише на зміні фази доби, бо зміна теми перемальовує всі кешовані
// тайли — щокадрове перемикання коштувало б надто дорого.

// ---- ДЕНЬ: фетр, картон, глянцевий пластик під настільною лампою ----
export const DAY = {
  night: false,
  ground: '#efe6d6', // стіл-макет
  green: '#bcd49b', // фетрові латки парків
  water: '#6FC6D9', // глянцева смола
  waterEdge: '#4fb0c6',
  waterHatch: 'rgba(255,255,255,.28)', // халфтон-блік (з «Ризолистівки»)
  road: '#C9B9A3', // дорожня шпаклівка, не сірий асфальт
  roadMinor: '#d6c8b4',
  roadEdge: '#A08D74', // «приклеєність» дороги до макета
  lane: 'rgba(255,246,227,.85)', // розмітка — вершкова, не біла
  laneCenter: 'rgba(255,246,227,.95)',
  rail: '#b3a692',
  building: '#E8C9A0', // картонно-фетрові панельки
  buildingSide: '#c9a578', // бік/тінь
  buildingEdge: '#d9765b', // теракотовий кант даху
  buildingLift: 0.42,
  buildingShadowDir: [0.55, 0.83],
  pool: null, // удень плям світла немає
  // листівка
  cardBg: '#f6f1e6',
  cardInk: '#26221a',
  cardInkSoft: 'rgba(38,34,26,.62)',
  cardChip: 'rgba(0,0,0,.05)',
  cardEdge: 'rgba(0,0,0,.10)',
  cardVignette: 'rgba(20,18,12,.26)',
};

// ---- НІЧ: сузір'я бурштину в чорнильно-синьому, не в чорному ----
export const NIGHT = {
  night: true,
  ground: '#131b3a',
  green: '#16243f',
  water: '#0d2438',
  waterEdge: '#16354f',
  waterHatch: 'rgba(180,220,255,.10)',
  road: '#1a2036',
  roadMinor: '#161c30',
  roadEdge: '#0e1428',
  lane: 'rgba(255,246,227,.22)', // вночі розмітка ледь помітна — не кричить
  laneCenter: 'rgba(255,223,160,.30)',
  rail: '#232a44',
  building: '#3a3f52', // силует панельки
  buildingSide: '#232840',
  buildingEdge: '#FFDFA0', // теплий кант на освітленому краї замість вікон-сузір'їв
  // (будівлі малюються як footprint+зсунутий бік, не 3D-коробки — вікна на них неможливі)
  buildingLift: 0.42,
  buildingShadowDir: [0.55, 0.83],
  pool: 'rgba(255,184,77,.20)', // бурштинова пляма світла на землі біля будинку
  cardBg: '#131b3a',
  cardInk: '#F3E9D2',
  cardInkSoft: 'rgba(243,233,210,.66)',
  cardChip: 'rgba(255,255,255,.08)',
  cardEdge: 'rgba(255,223,160,.22)',
  cardVignette: 'rgba(5,8,20,.45)',
};

/** Активні токени (мутуються на місці, щоб імпорти лишались валідними). */
export const THEME = { ...DAY };

/** Застосувати набір токенів. */
export function setTheme(patch) {
  Object.assign(THEME, patch || {});
}
